<template>
	<div class="admin-main">
		<div class="admin-top flex-rcc">
			经营资料
		</div>
		<van-form validate-first @submit="onSubmit" class="form-box">
			<div class="field-box">
				<van-field v-model="registration" registration="card" label="商户简称：" placeholder="请输入商家简称，支付成功页面展示" :rules="[{ required: true, message: '请输入商家简称，支付成功页面展示' }]"></van-field>
				<div class="remind">示例值：张三餐饮店</div>
			</div>
			<div class="field-box">
				<van-field v-model="phone" name="services" label="客服电话：" placeholder="请输入客服电话/手机号" :rules="[{ required: true, message: '请输入客服电话/手机号' }]"></van-field>
				<div class="remind">在交易记录中向买家展示，请确保电话畅通以便平台回拨确认。</div>
			</div>
			<div class="field-box">
				<van-field v-model="name" name="name" label="门店名称：" placeholder="请填写门店名称" :rules="[{ required: true, message: '请填写门店名称' }]"></van-field>
			</div>
			<div class="field-box">
				<van-field v-model="name" name="name" label="门店省市编码：" placeholder="请输入邮政编码" :rules="[{ required: true, message: '请输入邮政编码' }]"></van-field>
			</div>
			<div class="field-box">
				<van-field v-model="name" name="name" label="门店地址：" placeholder="请填写门店详细地址" :rules="[{ required: true, message: '请填写门店详细地址' }]"></van-field>
			</div>
			<div class="field-box">
				<van-field name="uploader" label="门店门头照片：">
					<template #input>
						<van-uploader v-model="uploader" :max-count="9"></van-uploader>
					</template>
				</van-field>
			</div>
			<div class="field-box">
				<van-field name="uploader" label="门店环境照片：">
					<template #input>
						<van-uploader v-model="uploader" :max-count="9"></van-uploader>
					</template>
				</van-field>
			</div>
			<div class="bottom-bar-placeholder"></div>
			<div class="admin-bottom-bar">
				<van-button native-type="submit" class="button-default" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" >
					下一步
				</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: "index",
		data () {
      return{
        radiod: 0,
        uploader: [],
        services: '',
        registration: '',
        name: '',
			}
		},
    computed: {
      ...mapState(['isApp', 'openId'])
    },
    methods: {
			next () {},
      onSubmit(values) {
        console.log('submit', values)
      }
    }
  };
</script>

<style scoped lang="stylus">
	.van-cell
		padding 5px 2px !important
		&:after
			border none !important
			border-bottom 0 !important
</style>
